export const BEGIN_AJAX_CALL = "BEGIN_AJAX_CALL";
export const AJAX_CALL_ERROR = "AJAX_CALL_ERROR";
export const END_AJAX_CALL = "END_AJAX_CALL";

export const SIGNAL_R_EVENT_RECEIVED = "SIGNAL_R_EVENT_RECEIVED";
export const BEGIN_ASYNC_COMMAND = "BEGIN_ASYNC_COMMAND";
export const END_ASYNC_COMMAND = "END_ASYNC_COMMAND";

//NOTIFICATIONS
export const ADD_NOTIFICATION = "ADD_NOTIFICATION";
export const LOAD_NOTIFICATIONS_SUCCESS = "LOAD_NOTIFICATIONS_SUCCESS";

//USER
export const LOAD_USER_INFO_STARTED = "LOAD_USER_INFO_STARTED";
export const LOAD_USER_INFO_SUCCESS = "LOAD_USER_INFO_SUCCESS";
export const LOAD_USER_INFO_FAILED = "LOAD_USER_INFO_FAILED";
export const INVALIDATE_USER_INFO = "INVALIDATE_USER_INFO";

//DASHBOARD
export const ALL_FRONTEND_NOTIFICATIONS_DISMISSED = "ALL_FRONTEND_NOTIFICATIONS_DISMISSED";

//server events
export * from "../eventTypes";
